import {
  Calendar,
  ClipboardList,
  FileCheck2,
  Users,
  Wallet,
  type LucideIcon,
} from 'lucide-react';

// Chaveado pelo texto exato das features vindas do backend (domain/plans.py) —
// usado tanto na landing page (Pricing.tsx) quanto no /cadastro (SignupPage.tsx).
export const FEATURE_ICONS: Record<string, LucideIcon> = {
  'Profissionais ilimitados': Users,
  'Agenda': Calendar,
  'Cadastro de pacientes e prontuário': ClipboardList,
  'Financeiro e relatórios': Wallet,
  'TISS/TUSS': FileCheck2,
};

export const FEATURE_DESCRIPTIONS: Record<string, string> = {
  'Profissionais ilimitados': 'Adicione quantos profissionais precisar, sem custo extra por assento.',
  'Agenda': 'Marque, remarque e acompanhe consultas em tempo real.',
  'Cadastro de pacientes e prontuário': 'Histórico clínico completo e seguro, sempre à mão.',
  'Financeiro e relatórios': 'Controle de pagamentos, repasses e indicadores da clínica.',
  'TISS/TUSS': 'Faturamento de convênios direto pela plataforma.',
};
